import type { HubPersona } from '../shared';
import type { SearchState } from './state/data/searchState';
import type { UserConfiguration } from './state/data/UserConfiguration';
import type { ContactFoldersState } from './state/data/contactFoldersState';
import type { ContactFoldersLoadingState } from './state/view/contactFoldersLoadingState';
import type { NavigationState } from './state/view/navigationState';
import type { LayoutState } from './state/view/layoutState';
import type { AsyncDialogState } from './state/view/asyncDialogState';
import type { HubState } from './state/data/hubDataState';
import type { GroupsHubDataState } from './state/data/groupsHubDataState';
import type { CreateEditMode } from './state/view/createEditorsState';
import type { MailComposeState } from './state/view/mailComposeState';
import type { EditContactOptionsState } from './state/view/editContactOptionsState';
import type { PendingActionsMap } from './state/view/groupsPendingActionsState';

export type HubPersonasMap = { [hubPersonaId: string]: HubPersona };

export const enum LivePersonaCardInitializationState {
    NotInitialized = 1,
    Done,
    Error,
}

export const enum LivePersonaEditorInitializationState {
    NotInitialized = 1,
    Done,
    Error,
}

export interface AppDataState {
    readonly userConfiguration: UserConfiguration;
    readonly personas: HubPersonasMap;
    readonly searchState: SearchState;
    readonly contactFoldersState: ContactFoldersState;
    readonly hubState: HubState;
    readonly groupsHubState: GroupsHubDataState;
}

export interface AppViewState {
    readonly livePersonaCardInitializationState: LivePersonaCardInitializationState;
    readonly layoutState: LayoutState;
    readonly navigationState: NavigationState;
    readonly contactFoldersLoadingState: ContactFoldersLoadingState;
    readonly asyncDialogState: AsyncDialogState;
    readonly createEditMode?: CreateEditMode;
    readonly mailComposeState: MailComposeState;
    readonly editContactOptions: EditContactOptionsState;
    readonly commandBarActionStateMap: PendingActionsMap;
}

export interface AppState {
    view: AppViewState;
    data: AppDataState;
}

export const appStatePackageStateKey = 'appstate';

export function getAppState(rootState: {}): AppState {
    return rootState[appStatePackageStateKey];
}

export function getPackageState<T>(
    rootState: {},
    packageStateKey: string
): { packageState: T; appState: AppState } {
    return {
        packageState: rootState[packageStateKey] as T,
        appState: rootState[appStatePackageStateKey] as AppState,
    };
}
